import React from 'react';
import './TransactionRecordSkeleton.css';

const TransactionRecordSkeleton = () => {
  const rows = Array.from({ length: 10 });
  const columns = Array.from({ length: 6 });

  return (
    <div className="trx-record-skeleton-root" aria-busy="true" aria-live="polite">
      <div className="trx-record-skeleton-header">
        <div className="trx-record-skeleton-title trx-record-skeleton-block" />
        <div className="trx-record-skeleton-header-controls">
          <div className="trx-record-skeleton-search trx-record-skeleton-block" />
          <div className="trx-record-skeleton-circle trx-record-skeleton-block" />
          <div className="trx-record-skeleton-button trx-record-skeleton-block" />
        </div>
      </div>

      <div className="trx-record-skeleton-table">
        <div className="trx-record-skeleton-table-head">
          {columns.map((_, idx) => (
            <div key={idx} className="trx-record-skeleton-th trx-record-skeleton-block" />
          ))}
        </div>
        <div className="trx-record-skeleton-table-body">
          {rows.map((_, rIdx) => (
            <div key={rIdx} className="trx-record-skeleton-tr">
              {columns.map((_, cIdx) => (
                <div key={cIdx} className="trx-record-skeleton-td trx-record-skeleton-block" />
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="trx-record-skeleton-pagination">
        <div className="trx-record-skeleton-text trx-record-skeleton-block" />
        <div className="trx-record-skeleton-pill trx-record-skeleton-block" />
        <div className="trx-record-skeleton-text trx-record-skeleton-block" />
        <div className="trx-record-skeleton-page-btns">
          <div className="trx-record-skeleton-pill trx-record-skeleton-block" />
          <div className="trx-record-skeleton-pill trx-record-skeleton-block" />
          <div className="trx-record-skeleton-pill trx-record-skeleton-block" />
        </div>
      </div>
    </div>
  );
};

export default TransactionRecordSkeleton;
